import React, { useState, useEffect } from 'react';
import axios from 'axios';

const STATUS_COLORS = { submitted: '#888', under_review: '#c77700', approved: '#2e7d32', denied: '#cc0000', refile_requested: '#6a1b9a' };
const STATUS_LABELS = { submitted: 'Submitted', under_review: 'Under Review', approved: 'Approved', denied: 'Denied', refile_requested: 'Refile Requested' };
const REASON_LABELS = {
  sold: 'Sold', traded: 'Traded', stolen: 'Stolen', total_loss: 'Total loss',
  moved_from_town: 'Moved from town', moved_from_state: 'Moved from state', junked: 'Junked',
  repossessed: 'Repossessed', exempt: 'Exempt', other: 'Other',
};

function MyFilings() {
  const [filings, setFilings] = useState([]);
  const [abatements, setAbatements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const token = localStorage.getItem('token');
  
  useEffect(() => {
    if (!token) {
      window.location.href = '/login';
      return;
    }
    Promise.all([fetchMyFilings(), fetchMyAbatements()]).finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Separate request so a problem loading abatements doesn't hide the Form of List filings
  const fetchMyAbatements = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/excise/my-abatements`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAbatements(response.data);
    } catch (err) {
      if (err.response?.status !== 401) setError('Failed to load your excise abatements.');
    }
  };

  const fetchMyFilings = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/filings/my-filings`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFilings(response.data);
    } catch (err) {
      if (err.response?.status === 401) {
        window.location.href = '/login';
      } else {
        setError('Failed to load your filings.');
      }
    }
  };

  const handleSignOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userEmail');
    window.location.href = '/';
  };

  const handleStartNewFiling = () => {
    window.location.href = '/';
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>

        <div style={styles.header}>
          <h1 style={styles.title}>MAtownforms</h1>
          <button style={styles.signOutButton} onClick={handleSignOut}>Sign Out</button>
        </div>

        <div style={styles.subHeader}>
          <h2 style={styles.subtitle}>My Filings</h2>
          <button style={styles.newFilingButton} onClick={handleStartNewFiling}>
            + Start New Filing
          </button>
        </div>

        {error && <p style={styles.error}>{error}</p>}

        {loading ? (
          <p style={styles.loading}>Loading your filings...</p>
        ) : filings.length === 0 && abatements.length === 0 ? (
          <div style={styles.emptyBox}>
            <p style={styles.emptyText}>You haven't filed anything yet.</p>
            <button style={styles.button} onClick={handleStartNewFiling}>
              Start Your First Filing
            </button>
          </div>
        ) : filings.length > 0 && (
          <table style={styles.table}>
            <thead>
              <tr>
                {['Filing Number', 'Form', 'Town', 'Year', 'Property Location', 'Submitted', ''].map(h => (
                  <th key={h} style={styles.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filings.map((filing, i) => (
                <tr key={filing.id} style={{ backgroundColor: i % 2 === 0 ? '#f8fafc' : '#ffffff' }}>
                  <td style={styles.td}>
                    <span style={styles.filingRef}>{filing.filing_reference || '—'}</span>
                  </td>
                  <td style={styles.td}>
                    <span style={filing.form_type === 'form_2' ? styles.badgeForm2 : styles.badgeForm2HF}>
                      {filing.form_type === 'form_2' ? 'Form 2' : 'Form 2HF'}
                    </span>
                  </td>
                  <td style={styles.td}>{filing.town_or_city}</td>
                  <td style={styles.td}>{filing.fiscal_year}</td>
                  <td style={styles.td}>{filing.property_location}</td>
                  <td style={styles.td}>
                    {filing.submitted_at ? new Date(filing.submitted_at).toLocaleDateString() : '—'}
                  </td>
                  <td style={styles.td}>
                    <button
  style={styles.viewButton}
  onClick={() => window.location.href = `/filing-view?id=${filing.id}`}
>
  View
</button>
<button
  style={styles.refileButton}
  onClick={() => window.location.href = `/?refile=${filing.id}`}
  title="Coming soon"
  disabled
>
  Refile
</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {!loading && abatements.length > 0 && (
          <>
            <h2 style={{ ...styles.subtitle, marginTop: '36px', marginBottom: '16px' }}>Motor Vehicle Excise Abatements</h2>
            <table style={styles.table}>
              <thead>
                <tr>
                  {['Filing Number', 'Town', 'Bill Year', 'Plate', 'Reason', 'Status', 'Submitted'].map(h => (
                    <th key={h} style={styles.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {abatements.map((a, i) => (
                  <tr key={a.id} style={{ backgroundColor: i % 2 === 0 ? '#f8fafc' : '#ffffff' }}>
                    <td style={styles.td}><span style={styles.filingRef}>{a.filing_reference || '—'}</span></td>
                    <td style={styles.td}>{a.town_name || a.town_code}</td>
                    <td style={styles.td}>{a.bill_year}</td>
                    <td style={styles.td}>{a.plate_number}</td>
                    <td style={styles.td}>{REASON_LABELS[a.reason] || a.reason}</td>
                    <td style={styles.td}>
                      <span style={{ ...styles.statusBadge, backgroundColor: STATUS_COLORS[a.status] || '#888' }}>
                        {STATUS_LABELS[a.status] || a.status}
                      </span>
                    </td>
                    <td style={styles.td}>{a.submitted_at ? new Date(a.submitted_at).toLocaleDateString() : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    padding: '40px 20px',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    maxWidth: '1000px',
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  title: {
    color: '#1a3a5c',
    fontSize: '22px',
    margin: 0,
  },
  signOutButton: {
    padding: '8px 16px',
    backgroundColor: 'transparent',
    border: '1px solid #1a3a5c',
    color: '#1a3a5c',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  },
  subHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    borderBottom: '1px solid #eee',
    paddingBottom: '16px',
  },
  subtitle: {
    color: '#444',
    fontSize: '18px',
    margin: 0,
  },
  newFilingButton: {
    padding: '10px 20px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    cursor: 'pointer',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
  },
  th: {
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    padding: '10px 12px',
    textAlign: 'left',
    fontWeight: '600',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #eee',
    color: '#333',
  },
  statusBadge: {
    display: 'inline-block',
    padding: '3px 10px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '600',
    color: '#fff',
  },
  filingRef: {
    fontFamily: 'monospace',
    fontSize: '13px',
    color: '#1a3a5c',
    fontWeight: '600',
  },
  badgeForm2: {
    backgroundColor: '#e3f0fb',
    color: '#1a3a5c',
    padding: '3px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '600',
  },
  badgeForm2HF: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
    padding: '3px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '600',
  },
viewButton: {
  padding: '4px 12px',
  backgroundColor: '#1a3a5c',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '12px',
  marginRight: '4px',
},

  refileButton: {
    padding: '4px 12px',
    backgroundColor: '#aaa',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'not-allowed',
    fontSize: '12px',
  },
  loading: {
    textAlign: 'center',
    color: '#666',
    padding: '40px',
  },
  error: {
    color: '#cc0000',
    fontSize: '14px',
    marginBottom: '16px',
  },
  emptyBox: {
    textAlign: 'center',
    padding: '60px 20px',
  },
  emptyText: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '24px',
  },
  button: {
    padding: '12px 24px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
  },
};

export default MyFilings;